import React, { Component } from 'react';
import { Glyphicon, Label, Image, Col, Row } from 'react-bootstrap';
import CenterDetailsLink from '../../../common/components/CenterDetailsLink';
import { withNamespaces } from 'react-i18next';
import moment from 'moment';
import ui from '../../../common/services/ui';
import MapComponent from '../../../common/components/MapComponent';
import utils from '../../../common/services/utils';

class ClassDetails extends Component {

	renderOnlineLabel() {
		const { weeklyProgramItem, t } = this.props;
		return weeklyProgramItem && weeklyProgramItem.isRemote && <Label bsStyle='info' style={{ marginLeft: '5px' }}>{t('FO_Program_Online')}</Label>;
	}

	renderAvailabilityLabel() {
		const { availability, t } = this.props;

		let className = 'success';
		switch (availability) {
			case 'Yes':
				className = 'success';
				break;
			case 'No':
				className = 'danger';
				break;
			case 'Limited':
			case 'LastSpot':
				className = 'warning';
				break;
		}

		return availability && <Label bsStyle={className} style={{ marginLeft: '5px' }}>{t(`FO_Booking_Availability_${availability}`)}</Label>;
	}

	getTimesWithTimeZone(programItem) {
		const { enableUserTimeZone } = this.props;
		const center = programItem.center;

		const centerStartTimeString = moment().format('YYYY-MM-DDT') + programItem.startTime;
		const centerEndTimeString = moment().format('YYYY-MM-DDT') + programItem.endTime;
		const parentStartTimeMoment = enableUserTimeZone ? utils.convertToUserTime(centerStartTimeString, center) : moment(centerStartTimeString);
		const parentEndTimeMoment = enableUserTimeZone ? utils.convertToUserTime(centerEndTimeString, center) : moment(centerEndTimeString);

		return {
			startTime: parentStartTimeMoment,
			endTime: parentEndTimeMoment
		}
	}

	render() {
		const { weeklyProgramItem, upcomingLessonDates, enableUserTimeZone, t } = this.props;
		const grade = (weeklyProgramItem && weeklyProgramItem.grade) || { name: '', description: '' };
		const center = weeklyProgramItem && weeklyProgramItem.center;
		const avatarStyle = { width: 200, height: 200, lineHeight: '200px', fontSize: 45, display: 'inline-block', textAlign: 'center' };
		const teacher = weeklyProgramItem && weeklyProgramItem.teacher;
		const schedule = weeklyProgramItem && this.getTimesWithTimeZone(weeklyProgramItem);
		const term = weeklyProgramItem && weeklyProgramItem.term;

		return <div>
			{/*<p><GradeDetailsLink grade={grade} /></p>*/}
			<h3>{grade.name}</h3>
			<p><Glyphicon glyph='time' /> {ui.getWeekdayLabel(weeklyProgramItem.weekday)} {schedule && `${schedule.startTime.format('LT')} - ${schedule.endTime.format('LT')}`}
				{teacher && teacher.name ? ` ${t('FO_Booking_Form_WithTeacher')} ` : ''}
				{teacher && teacher.name ? <b>{weeklyProgramItem.teacher.name}</b> : ''}
				{this.renderOnlineLabel()}
				{this.renderAvailabilityLabel()}
			</p>
			<p>
				<CenterDetailsLink center={center} className='visible-xs' style={{ float: 'left' }} />
				{center && <span className='hidden-xs' style={{ float: 'left' }}><Glyphicon glyph='map-marker' /> {center.name}</span>}
				{weeklyProgramItem.roomNumber ? `, ${weeklyProgramItem.roomNumber}` : ''}
				<span className='clearfix' />
			</p>
			{weeklyProgramItem.description && <p><Glyphicon glyph='info-sign' /> {weeklyProgramItem.description}</p>}
			<p><Glyphicon glyph='calendar' /> {upcomingLessonDates.length > 0 ? upcomingLessonDates.map(x => (enableUserTimeZone ? utils.convertToUserTime(x, center) : moment(x)).format('LL')).join('; ') : t('FO_Booking_Form_NoUpcomingClasses')}</p>
			{<div dangerouslySetInnerHTML={{ __html: grade.description }} style={{ marginTop: '20px', marginBottom: '20px' }} />}

			{term && term.themeDescription && <div dangerouslySetInnerHTML={{ __html: term.themeDescription }} style={{ marginTop: '20px', marginBottom: '20px' }} />}

			<h4 className='hidden-xs'>{t('FO_Booking_CenterLocation')}</h4>
			{center && <div className='hidden-xs' style={{ marginTop: '20px', marginBottom: '20px' }}>
				{center.latitude && center.longitude && <MapComponent
					latitude={center.latitude}
					longitude={center.longitude}
					isSingleMarker
				/>}
				<h5>{center.name}</h5>
				{center.address && <p><Glyphicon glyph='map-marker' /> {center.address}</p>}
				<p>{center.addressDescription}</p>
				{center.phoneNumber && <p><Glyphicon glyph='earphone' /> {center.phoneNumber}</p>}
				{center.email && <p><Glyphicon glyph='envelope' /> {center.email}</p>}
				{center.additionalInfo && <p> <Glyphicon glyph='info-sign' /> <span dangerouslySetInnerHTML={{ __html: center.additionalInfo }} /></p>}
			</div>}
			{teacher && (teacher.photoUrl || teacher.bio) && <React.Fragment>
				<h4>{t('FO_Booking_MeetTeacher')}</h4>
				<Row>
					<Col sm={4} style={{ textAlign: 'center', padding: '20px' }}>
						{teacher.photoUrl ? <Image className={'circle-icon'} width={200} height={200} src={teacher.photoUrl} alt={teacher.name} /> :
							<div className={'circle-icon text-white bg-purple'} style={avatarStyle}>{ui.getAvatarName(teacher.firstName, teacher.lastName)}</div>}
						<h5 className='visible-xs' style={{ marginTop: 20, marginBottom: 0 }}>{teacher.name}</h5>
					</Col>
					<Col sm={8} style={{ padding: '20px' }}>
						<h5 className='hidden-xs'>{teacher.name}</h5>
						<p>{teacher.bio}</p>
					</Col>
				</Row>
			</React.Fragment>}
		</div>;
	}
}

export default withNamespaces()(ClassDetails);